import { styled } from "@phntms/css-components";
import styles from "./styles.module.scss";
export const CardGridContainer = styled('div', {
  css: [styles.cardGridContainer, 'card-grid-container'],

})

export const Cards = styled('div', {
  css: [styles.cardGrid, 'card-grid'],
  variants: {
    cols: {
      5: styles.cols5,
      4: styles.cols4,
      3: styles.cols3,
      2: styles.cols2,
    },
    align: {
      left: styles.alignLeft,
      center: styles.alignCenter,
      right: styles.alignRight,
    }
  },
  defaultVariants: {
    cols: 4,
  }
})
